<style scoped>
    .page-wrap{
        display: inline-block;
        vertical-align: middle;
        width: 350px;
    }
    .comment{
        text-align: left;
        padding: 5px;
        border: 1px solid #dddee1;
        margin-bottom: 5px;
    }
    .comment-content{
        white-space: pre;
    }
</style>
<template>
    <div v-if="is_show">
        <Modal v-model="is_show" width="600">
            <p slot="header" style="color:#f60;text-align:center">
               {{record.account}} {{record.month}} 工资问题反馈
            </p>
            <div class="text-center">
                <div class="line">
                    <i-input type="textarea" :rows="3" v-model="comment_content" placeholder="输入留言..."></i-input>
                </div>
                <Button type="primary" long :loading="updating" @click="submitComment">提交</Button>
                <div class="hr"></div>
                <div class="line text-left" v-if="page_info.total">
                    <Page
                        class="page-wrap"
                        size="small"
                        show-total
                        show-elevator
                        :current="page_info.current"
                        :total="page_info.total"
                        :page-size="page_info.page_size"
                        @on-change="pageChange">
                    </Page>
                    <Button size="small" type="primary" :loading="loading" @click="reloadComments">刷新</Button>
                </div>
                <div class="comment" v-for="comment in comments" :key="comment.id">
                    <div class="">
                        <span>{{comment.account}}</span>
                        <span class="color-grey">{{fromNow(comment.updated_at)}}</span>
                    </div>
                    <div class="">
                        <div class="comment-content" v-html="comment.content"></div>
                    </div>
                </div>
                <Spin fix v-if="loading"></Spin>
            </div>
            <div class="text-right" slot="footer">
                <Button @click="hide">关闭</Button>
            </div>
        </Modal>
    </div>
</template>
<script>
    export default {
        props: {
            record: {
                type: Object
            }
        },
        data(){
            return {
                is_show: false,
                params: {
                    link_model_type: 'WageRecord',
                    link_model_id: this.record.id,
                    page: 1
                },
                page_info: {
                    current: 1,
                    total: 0,
                    page_size: 10
                },
                comments: [],
                comment_content: '',
                loading: false,
                updating: false
            }
        },
        computed: {
            //
        },
        watch: {
            record(){
                this.params.link_model_id = this.record.id;
                this.params.page = 1;
            }
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            show(){
                this.is_show = true;
                this.getComments();
            },
            hide(){
                this.is_show = false;
            },
            pageChange(page){
                this.params.page = page;
                this.getComments();
            },
            reloadComments(){
                this.params.page = 1;
                this.getComments();
            },
            getComments(){
                if(this.loading) return;
                this.loading = true;
                Util.ajax.get(Util.api.get_comments, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    if(res.code === 1){
                        //成功
                        let data = res.data;
                        this.comments = data.comments;
                        this.page_info.current = data.cur_page;
                        this.page_info.page_size = data.per_page;
                        this.page_info.total = data.total_count;
                    }else{
                        //失败
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    console.log(e);
                    this.loading = false;
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            submitComment(){
                if(!this.comment_content){
                    this.$Modal.warning({
                        title: '提示',
                        content: '内容不能为空'
                    });
                    return;
                }
                if(this.updating) return;
                this.updating = true;
                Util.ajax.post(Util.api.comment_wage_record, {
                    link_model_type: 'WageRecord',
                    link_model_id: this.record.id,
                    content: this.comment_content
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    setTimeout(()=>{
                        this.updating = false;
                    }, 800);
                    if(res.code === 1){
                        this.comment_content = '';
                        this.reloadComments();
                        this.$Message.success('提交成功');
                        /*let data = res.data;
                        let comment = data.comment;
                        Util.insertOrUpdateArrayItem(this.comments, comment, true);*/
                    }else{
                        this.$Modal.warning({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.updating = false;
                    this.$Modal.warning({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            fromNow(time){
                return Util.fromNow(time);
            }
        }
    }
</script>
